import TicketAlertModal, { TicketAlertModalProps } from './TicketAlertModal';

export type { TicketAlertModalProps };
export default TicketAlertModal;
